import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../../services/api";
import HeaderSession from "../../../../utils/headerSession";
import Loading from "../../../../load/loading";
// import DateHora from "../../../utils/dateHora";
import { useSelector } from "react-redux";
import FerramentaNavegacaoExportacao from "../../../../utils/paginacao";
import ListaSolicitacao from "./listaSolicitacao";
import RegisterAccess from "../../../../utils/registerAccess";
import SearchEstabelecimento from "../../../../utils/searchEstabelecimento";
import HeaderGestorConfigs from "../../../../utils/headerGestorConfigs";
import TabelaLoading from "../../../../load/tabelaLoading";

export default function SolicitacoesDeLicenciamento() {
  const user = useSelector((state) => state.account.user);
  const navigate = useNavigate();
  const [tipo, setTipo] = useState("");
  const [status, setStatus] = useState("");
  const [provincia, setProvincia] = useState("");
  const [estabelecimentos, setEstabelecimentos] = useState("");
  const [estabelecimentosInspeccionados, setEstabelecimentosInspeccionados] =
    useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(50);
  const [, setOrder] = useState("");
  const [configLista, setConfigLista] = useState("");

  useEffect(() => {
    setEstabelecimentos('')
  }, [tipo, status, provincia])


  useEffect(() => {
    setEstabelecimentos("");

    if (user?.seccao === "Licenciamento" && user?.funcao === "Técnico") {
      navigate("admin/recepcao/solicitacoes-de-licenciamento");
    }

    const fetchData = async () => {
      try {
        if (
          user?.seccao === "Licenciamento" &&
          user?.funcao === "Chefe de Secção"
        ) {
          const { data } = await api.get(
            `/estabelecimentos?page=${page}&perPage=${perPage}&status=Analisado&tipoId=${tipo}&provincia=${provincia}`
          );
          setEstabelecimentos(data.estabelecimentos);
          setConfigLista(data);
        }

        if (
          user?.seccao === "Licenciamento" &&
          user?.funcao === "Chefe de Departamento"
        ) {
          const [analisado, inspeccionado] = await Promise.all([
            api.get(
              `/estabelecimentos?page=${page}&perPage=${perPage}&status=Analisado Chefe de Secção&tipoId=${tipo}&provincia=${provincia}`
            ),
            api.get(
              `/estabelecimentos?page=${page}&perPage=${perPage}&status=Inspecção Realizada&tipoId=${tipo}&provincia=${provincia}`
            ),
          ]);
          setEstabelecimentos(analisado.data.estabelecimentos);
          setConfigLista(analisado.data);
          setEstabelecimentosInspeccionados(
            inspeccionado.data.estabelecimentos
          );
        }

        if (user?.seccao === "Inspecção" && user?.funcao === "Inspector") {
          const { data } = await api.get(
            `/estabelecimentos?page=${page}&perPage=${perPage}&status=Inspecção Agendada&tipoId=${tipo}&provincia=${provincia}`
          );
          setEstabelecimentos(data.estabelecimentos);
          setConfigLista(data);
        }

        if (
          user?.seccao === "Licenciamento" &&
          user?.funcao === "Director Geral"
        ) {
          const { data } = await api.get(
            `/estabelecimentos?page=${page}&perPage=${perPage}&status=Deferimento&tipoId=${tipo}&provincia=${provincia}`
          );
          setEstabelecimentos(data.estabelecimentos);
          setConfigLista(data);
        }
      } catch (err) {
        // console.error(err);
      }
    };

    fetchData();
  }, [page, tipo, perPage, provincia, user?.funcao, user?.seccao, navigate]);

  return (
    <>
      <RegisterAccess page={"solicitações de licenciamento"} />
      <HeaderSession title="LISTA DE SOLICITAÇÕES DE LICENCIAMENTO" />
      <SearchEstabelecimento
        setEstabelecimentos={setEstabelecimentos}
        setTipo={setTipo}
        setStatus={setStatus}
        setProvincia={setProvincia}
        placeholder={"Filtra por nome, número de entrada, data"}
        tipo={tipo}
        provincia={provincia}
      />

      {estabelecimentos ? (
        <>
          <ListaSolicitacao estabelecimentos={estabelecimentos} >
            <FerramentaNavegacaoExportacao
              configLista={configLista}
              lista={estabelecimentos}
              page={page}
              setPage={setPage}
              setPerPage={setPerPage}
              setOrder={setOrder}
            />
          </ListaSolicitacao>
        </>
      ) : (
        <TabelaLoading />
      )}

      {/* VER ESTABELECIMENTOS QUE JA FORAM INSPECIONADOS VISAO APENAS PARA CHEFE DE DEPARTAMENTO */}
      {estabelecimentosInspeccionados && (
        <>
          <HeaderGestorConfigs title={'ESTABELECIMENTO JÁ INSPECIONADOS'} />
          <ListaSolicitacao
            estabelecimentos={estabelecimentosInspeccionados}
          >
            <FerramentaNavegacaoExportacao
              configLista={configLista}
              lista={estabelecimentos}
              page={page}
              setPage={setPage}
              setPerPage={setPerPage}
              setOrder={setOrder}
            />
          </ListaSolicitacao>
        </>
      )}
    </>
  );
}
